module.exports = __webpack_public_path__ + "static/media/W3@1.5x.29f42020.png";